'use client';

import { defaultProps } from "../TextField.defaultProps.js";
function parseProps({
  caption,
  disabled,
  error,
  hiddenLabel,
  icon,
  iconPosition = defaultProps.iconPosition,
  iconStyle = defaultProps.iconStyle,
  label,
  a11yLabel,
  prefix,
  required,
  suffix,
  className,
  ...inputProps
}) {
  const extraContentProps = {
    icon,
    iconPosition,
    iconStyle,
    prefix,
    suffix
  };
  const formControlProps = {
    caption,
    disabled,
    error,
    hiddenLabel,
    label: {
      children: label
    },
    a11yLabel,
    required,
    className
  };
  return {
    extraContentProps,
    formControlProps,
    inputProps
  };
}
export {
  parseProps
};
